import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { theirRole } = commonConfigValues

const {
  helpers: { keepInLength, getUserProfileLocal, getLoginFromMail, getUserId }
} = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const communicationType = [
  { id: 1, label: 'Email' },
  { id: 2, label: 'Email incl. Report' },
  { id: 3, label: 'Fax' },
  { id: 4, label: 'Fax incl. Report' },
  { id: 5, label: 'In Person' },
  { id: 6, label: 'Letter' },
  { id: 7, label: 'Letter incl. Report' },
  { id: 8, label: 'Phone Call' },
  { id: 9, label: 'SMS Text' },
  { id: 10, label: 'Social Media Call' },
  { id: 11, label: 'Social Media Text' },
  { id: 12, label: 'Other' }
]

export const communicationDirection = [
  { id: 1, label: 'Incoming' },
  { id: 2, label: 'Outgoing' }
]

export const communicationSubject = [
  { id: 1, label: 'Car Related' },
  { id: 2, label: 'Finance Related' },
  { id: 3, label: 'Fire Safety Related' },
  { id: 4, label: 'Health & Safety Related' },
  { id: 5, label: 'HIQA Related' },
  { id: 6, label: 'HR Related' },
  { id: 7, label: 'Maintenance Related' },
  { id: 8, label: 'Monitoring Related' },
  { id: 9, label: 'On-Call Related' },
  { id: 10, label: 'Payroll Related' },
  { id: 11, label: 'Roster Related' },
  { id: 12, label: 'Training Related' },
  { id: 12, label: 'Other' }
]

export const valueTable = {
  communicationType,
  communicationDirection,
  communicationSubject
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'centre.ui',
      'centre.name',
      'communication.date',
      'communication.direction',
      'communication.type',
      'communication.initiated',
      'communication.theirRoleInitiated',
      'communication.notes'
    ]
  }
]

export const defaultSorting = [
  { columnName: 'communication.date', direction: 'asc' }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.ui',
    title: 'Centre UI',
    minSpace: 'Centre UI ',
    getCellValue: row => row['id'],
    formField: true
  },
  {
    name: 'register.sector',
    title: 'Centre Sector',
    minSpace: 'Centre Sector ',
    formField: true,
    hidden: getUserProfileLocal().role === 'Level 1'
  },
  {
    name: 'register.organisationName',
    title: 'Centre Organisation Name',
    minSpace: 'Centre Organisation ',
    formField: true,
    hidden: getUserProfileLocal().role === 'Level 1'
  },
  {
    name: 'register.name',
    title: 'Centre / Unit Name',
    // hidden: true,
    minSpace: 'Centre / Unit ',
    formField: true
  },

  {
    name: 'communication.date',
    title: 'Communication Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Communication '
  },
  {
    name: 'communication.time',
    title: 'Communication Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Communication '
  },
  {
    name: 'communication.direction',
    title: 'Communication Direction',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(valueTable.communicationDirection, [
        'id',
        parseInt(row[`communication.direction`], 10)
      ])
        ? _.find(valueTable.communicationDirection, [
            'id',
            parseInt(row[`communication.direction`], 10)
          ]).label
        : row[`communication.direction`],
    options: 'communicationDirection',
    filterField: true,
    minSpace: 'Communication Dir'
  },
  {
    name: 'communication.type',
    title: 'Communication Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(valueTable.communicationType, [
        'id',
        parseInt(row[`communication.type`], 10)
      ])
        ? _.find(valueTable.communicationType, [
            'id',
            parseInt(row[`communication.type`], 10)
          ]).label
        : row[`communication.type`],
    options: 'communicationType',
    filterField: true,
    minSpace: 'Communication '
  },
  {
    name: 'communication.subject',
    title: 'Communication Subject',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(valueTable.communicationSubject, [
        'id',
        parseInt(row[`communication.subject`], 10)
      ])
        ? _.find(valueTable.communicationSubject, [
            'id',
            parseInt(row[`communication.subject`], 10)
          ]).label
        : row[`communication.subject`],
    options: 'communicationSubject',
    filterField: true,
    minSpace: 'Communication '
  },
  {
    name: 'communication.initiated',
    title: 'Communication Initiated By Name(s)',
    formField: true,
    maxChars: 50,
    filterField: true,
    minSpace: 'Initiaded By Name(s) '
  },
  {
    name: 'communication.theirRoleInitiated',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, [
        'id',
        parseInt(row[`communication.theirRoleInitiated`], 10)
      ])
        ? _.find(theirRole, [
            'id',
            parseInt(row[`communication.theirRoleInitiated`], 10)
          ]).label
        : row[`communication.theirRoleInitiated`],
    minSpace: 'Their Role ',
    options: 'theirRole',
    filterField: true
  },
  {
    name: 'communication.intended',
    title: 'Communication Intended to Reach Name',
    formField: true,
    maxChars: 50,
    filterField: true,
    minSpace: 'Communication Intended '
  },
  {
    name: 'communication.theirRoleIntended',
    title: 'Their Role',
    formField: true,
    type: 'select',
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role '
  },
  {
    name: 'communication.recipient',
    title: 'Actual Communication Recipient Name',
    formField: true,
    type: 'select',
    // options: 'personnel', //FROM PERSONNEL REGISTER
    filterField: true,
    minSpace: 'Actual Communication '
  },
  {
    name: 'communication.theirRoleRecipient',
    title: 'Their Role',
    formField: true,
    //AUTO CALC BASE ON PERSONNEL ROLE & STATUS ROLE
    filterField: true,
    minSpace: 'Their Role '
  },
  {
    name: 'communication.notes',
    title: 'Communication Notes',
    formField: true,
    maxChars: 300,
    filterField: true,
    minSpace: 'Communication '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'communication',
      historyName: 'communicationHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          // hint: 'Select Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const label = `${o.name} (register: ${o.id})`
            return { value: o.id, label: label }
          })
        }
      ]
    },

    {
      id: 2,
      name: 'com',
      activeName: 'communication',
      historyName: 'communicationHistory',
      label: 'Communication',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.date',
            label: 'Communication Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.time',
            label: 'Communication Time',
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.direction',
            label: 'Communication Direction',
            // hint: 'Select Direction',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.communicationDirection
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.type',
            label: 'Communication Type',
            // hint: 'Select Type',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.communicationType
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.subject',
            label: 'Communication Subject',
            // hint: 'Select Subject',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.communicationSubject
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'communication.initiated',
            label: 'Communication Initiated By Name(s)',
            // hint: 'Enter Communication Initiated',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.theirRoleInitiated',
            label: 'Their Role',
            // hint: 'Select Their Role',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'communication.intended',
            label: 'Communication Intended to Reach Name',
            // hint: 'Enter Communication Intended',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.theirRoleIntended',
            label: 'Their Role',
            // hint: 'Select Their Role',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.recipient',
            label: 'Actual Communication Recipient Name',
            // hint: 'Select RecipientName',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.users.filter(f => f.id > 0).map(o => {
              const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
              return { value: o.id, label: label }
            }),
            onChange: (e, v) => {
              change(formName, 'communication.theirRoleRecipient', v)
            }
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'communication.theirRoleRecipient',
            label: 'Their Role',
            disabled: true,
            required: showAsterix
          }
        ],

        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'communication.notes',
          label: 'Communication Notes',
          // hint: 'Enter Communication Notes',
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['communication']

export const errors = [1, 2]

export const defaultNew = {
  communication: {
    historyId: 'new',
    date: new Date(),
    time: new Date(),
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  communicationHistory: []
}

// "communications": [
//   {
// "communication": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "time": "T23:28:56.782Z",
//   "type" : 2,
//   "subject" : 2,
//   "direction" : 2,
//   "initiated": "aaa",
//   "theirRoleInitiated" : 2,
//   "intended": "daa",
//   "theirRoleIntended": 2,
//   "recipient" :2,
//   "theirRoleRecipient": 1,
//   "notes": "aa"
// },
// "communicationHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/centre/configs/communications.js